import { render, staticRenderFns } from "./InflationView.vue?vue&type=template&id=70f19ebc&"
import script from "./InflationView.vue?vue&type=script&lang=js&"
export * from "./InflationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports